import { buildGoogleMapsUrl } from '../utils/maps';
import { VideoEmbed } from '../components/VideoEmbed';

const fbPageUrl = 'https://www.facebook.com/ElfahmawiBoxingCenter/';
const bgUrl = 'https://graph.facebook.com/ElfahmawiBoxingCenter/picture?type=large';

const address = 'عين خالد عمارة علي حماد، أم الفحم، 3001000';
const mapsUrl = buildGoogleMapsUrl(address);

export function AinKhaledPage() {
  return (
    <div className="container" style={{ display: 'grid', gap: 16 }}>
      <section className="locationHeader">
        <div className="locationHeaderBg" style={{ backgroundImage: `url("${bgUrl}")` }} />
        <div className="locationHeaderContent">
          <div className="pillRow">
            <span className="badge">فرع</span>
            <span className="badge">عين خالد</span>
          </div>
          <h1 className="locationTitle">مركز الملاكمة الفحماوي - عين خالد</h1>
          <p className="muted" style={{ margin: 0, lineHeight: 1.9 }}>
            {address}
          </p>
          <div className="actions">
            <a className="btn btnPrimary" href={mapsUrl} target="_blank" rel="noreferrer">
              افتح في خرائط جوجل
            </a>
            <a className="btn" href={fbPageUrl} target="_blank" rel="noreferrer">
              افتح صفحة فيسبوك
            </a>
          </div>
          <p className="muted" style={{ margin: 0, fontSize: 13, lineHeight: 1.9 }}>
            ملاحظة: فيسبوك يمنع عرض الصور مباشرة كخلفية في مواقع خارجية أحيانًا، لذلك نستخدم
            صورة تعمل دائمًا مع رابط صفحة فيسبوك.
          </p>
        </div>
      </section>

      <section className="grid2">
        <div style={{ display: 'grid', gap: 14 }}>
          <VideoEmbed
            title="فيديو تيك توك 1"
            url="https://www.tiktok.com/@ameragbaria/video/7625320546699431189"
          />
          <VideoEmbed
            title="فيديو تيك توك 2"
            url="https://www.tiktok.com/@ameragbaria/video/7622688761041734932"
          />
        </div>

        <aside className="card section">
          <div className="titleRow">
            <h2 className="h2">الموقع</h2>
            <span className="badge">خرائط</span>
          </div>
          <p className="muted" style={{ margin: 0, lineHeight: 1.95 }}>
            {address}
          </p>
          <hr className="hr" />
          <div className="actions">
            <a className="btn btnPrimary" href={mapsUrl} target="_blank" rel="noreferrer">
              افتح في خرائط جوجل
            </a>
          </div>
        </aside>
      </section>
    </div>
  );
}

